export default "__VITE_ASSET__BImEiDue__"